import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Ng2SmartTableModule } from 'ng2-smart-table';
import { CKEditorModule } from 'ngx-ckeditor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CompanyRoutingModule } from './company-routing.module';
import { EditCompanyDataComponent } from './edit-company-data/edit-company-data.component';
import { CompanyDataDetailsComponent } from './company-data-details/company-data-details.component';
import { CompanyElectricityComponent } from './electricity/company-electricity.component';
import { CompanyGasComponent } from './gas/company-gas.component';
import { ElectricityConsumptionPlaceDetailsComponent } from './electricity/details/consumption-place/electricity-consumption-place-details.component';

import 'hammerjs';
import 'mousetrap';
import {GasConsumptionPlaceDetailsComponent} from './gas/details/consumption-place/gas-consumption-place-details.component';
import { LegalRepresentativesComponent } from './legal-representatives/legal-representatives.component';
import { PermissionsComponent } from './legal-representatives/permission-component/permissions.component';
import { OptionsComponent } from './legal-representatives/options-component/options.component';
import { InlineEditComponent } from './legal-representatives/inline-edit/inline-edit.component';
import { ActionsComponent } from './company-data-details/actions/actions.component';
import { ContractActionsComponent } from './common/contract-actions/contract-actions.component';
import { PlaceActionsComponent } from './common/place-actions/place-actions.component';
import {PublicModule} from '../../public/public.module';
import {SharedModule} from '../../shared/shared.module';
import {ViewCompanyDataComponent} from "./view-company-data/view-company-data.component";

@NgModule({
  declarations: [
    EditCompanyDataComponent,
    ViewCompanyDataComponent,
    CompanyDataDetailsComponent,
    CompanyElectricityComponent,
    CompanyGasComponent,
    ElectricityConsumptionPlaceDetailsComponent,
    GasConsumptionPlaceDetailsComponent,
    LegalRepresentativesComponent,
    PermissionsComponent,
    OptionsComponent,
    InlineEditComponent,
    ActionsComponent,
    ContractActionsComponent,
    PlaceActionsComponent
  ],
    imports: [
        CommonModule,
        NgbModule,
        Ng2SmartTableModule,
        ReactiveFormsModule,
        CompanyRoutingModule,
        CKEditorModule,
        FormsModule,
        PublicModule,
        SharedModule
    ],
  exports: [EditCompanyDataComponent, ViewCompanyDataComponent]
})
export class CompanyModule {
}
